import Vue from 'vue'
// import BootstrapVue from 'bootstrap-vue'
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
// import 'material-design-icons-iconfont/dist/material-design-icons.css'
import VueAxios from 'vue-axios'
import VueAuthenticate from 'vue-authenticate'
import axios from 'axios'
import Vuex from 'vuex'
import VueSessionStorage from 'vue-sessionstorage'
Vue.use(Vuex);

import App from './App'
import router from './router'
import store from './store'

// import 'vuetify/dist/vuetify.min.css'
import vuetify from './plugins/vuetify';
import { registerPlugins } from './plugins'
registerPlugins();
import { NetworkErrorAlert } from './utils/Alerts'

import backend_settings from './backend_settings';

// Global CSS Styles
import './sass/main.scss';

if (process.env.NODE_ENV === 'development') {
  Vue.config.backend_base_url = backend_settings.development;
} else {
  Vue.config.productionTip = false;
  Vue.config.backend_base_url = backend_settings.production;
}

// Enable iif backend supports a SSO auth scheme (OpenID, SAML...)
// NOTE we are currently limited to a single SSO method per instance
// with global activation for all sites/empresas/centros/whatever
Vue.config.SSO = {
  enabled: true,
  /* XXX what follows are EXAMPLES, set accordingly XXX *
   * name: what to display as link text tip             *
   * loginURL enables a link on our login to their SSO  *
   * logoutURL replaces our local logout method         *
   * If possible, build URLs using V.c.backend_base_url */
  name: "Esteve-Teijin SSO",
  loginURL: Vue.config.backend_base_url + '/saml/login',
  //logoutURL: Vue.config.backend_base_url + '/sso/logout',
}

// Vue.use(BootstrapVue)

Vue.use(VueAxios, axios)
Vue.use(VueAuthenticate, {
  baseUrl: Vue.config.backend_base_url,
  tokenType: 'Token',
})
Vue.use(VueSessionStorage)

Vue.prototype.$base = Vue.config.backend_base_url
Vue.prototype.$sso = Vue.config.SSO || { enabled: false }

// Global registration
axios.defaults.baseURL = Vue.config.backend_base_url + '/api/v1';

axios.interceptors.response.use(response => {
  return response;
}, error => {
 if (error.response && error.response.status === 401) {
  if (error.response.request
      && ! error.response.request.responseURL.endsWith('/token/login/')) {
    store.dispatch('RESET_STATE');
    store.dispatch('UserSession/purge_session');
    router.push('login');
  }
 } else if(error.response) {
  // Store message error into store to catch it in the error render
  store.commit('SET_MESSAGE', new NetworkErrorAlert(error));
 }
 throw error;
});

Vue.mixin({
  methods: {
    render_form_errors: function(err) {
      this.message = ''
      this.loading = false
      if (!err.body) {
        if (err.response) {
          if (err.response.data) err.body = err.response.data
          else err.body = err.response
        }
      }
      if (typeof err.body === 'string') this.message += err.body
      else {
        for (var fieldname in err.body) {
          if (err.body.hasOwnProperty(fieldname)) {
            if (fieldname != 'non_field_errors') {
              var fielddesc = fieldname
              var node = document.getElementById('label_' + fieldname)
              if (node) fielddesc = node.innerHTML
              this.message += '\n' + fielddesc + ': '
            }
            if (typeof err.body[fieldname] === 'string')
              this.message += err.body[fieldname] + '\n'
            else {
              for (var msg in err.body[fieldname])
                this.message += err.body[fieldname][msg] + '\n'
            }
          }
        }
      }
      if (!this.message) this.message += err
    },

    $t(/*...*/) {
      // Translate with vuetify
      return this.$vuetify.lang.translator(...arguments);
    },
  },
});

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App),
}).$mount('#app')
